import { Tab, Tabs } from '../../../../../components/common/TabCustom';
import ElementosGrid from "../../../../../components/controls/ElementosGrid";
import { useState } from "react";
import { useEntidad } from "../../../../../components/hooks";
import { ALERT_TYPE, OPERATION_MODE, ShowToastMessage, TRIBUTO_TYPE } from '@laramie/ui';
import {usePermissions} from "../../../../../components/hooks/usePermissions";
import {PERMISSIONS} from "../../../../../consts/permissions";

const ElementosTab = ({ state, UpdateEntity }) => {
    const [activeTab, setActiveTab] = useState()
    const [clases, setClases] = useState([]);
    const [getListEntidad,] = useEntidad({
        entidades: ['ClaseElemento'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                const clases = getListEntidad('ClaseElemento').filter(clase => clase.idTipoTributo === TRIBUTO_TYPE.CEMENTERIOS);
                setClases(clases);
                if (clases.length > 0) setActiveTab(`elementos-${clases[0].codigo}`);
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'ClaseElemento',
            timeout: 0
        }
    });
    const { hasPermission } = usePermissions();
    const canEditElementos = hasPermission(PERMISSIONS.ELEMENTO_EDIT);

    return (
        <Tabs
            id="tabs-comercio-elementos"
            activeKey={activeTab}
            className="m-top-20"
            onSelect={tab => setActiveTab(tab)}
        >
            {
                clases.map((clase, index) => {
                    return (
                        <Tab eventKey={`elementos-${clase.codigo}`} title={clase.nombre} key={`elementos-${index}`}>
                            <div className='tab-panel'>
                                <ElementosGrid
                                    processKey={state.processKey}
                                    disabled={state.mode === OPERATION_MODE.VIEW || !canEditElementos}
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        idClaseElemento: clase.id,
                                        list: state.entity.elementos
                                        // esta obsoleto porque ya no se vincula a los inhumados pero se deja el codigo como registro
                                        // de como vincular una entidad a un elemento
                                        // listEntities: [
                                        //     {
                                        //         key: "Inhumado",
                                        //         value: "Inhumado",
                                        //         children: state.entity.inhumados.filter(f => f.idTipoConstruccionFuneraria === clase.tipoConstruccionFuneraria.id).map(x => { return { key: x.id, value: `${x.nombre} ${x.apellido}` } })
                                        //     }
                                        // ]
                                    }}
                                    onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                />
                            </div>
                        </Tab>
                    );
                })
            }
        </Tabs>
    )
}

export default ElementosTab
